module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/96f3b5b0b66b8145d40cb2614e7105a8.png";